import React, { memo } from 'react'

const ArrowUpIcon: React.FC = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M14.4732 7.13862C14.4113 7.2006 14.3378 7.24977 14.2569 7.28332C14.1759 7.31687 14.0892 7.33414 14.0016 7.33414C13.914 7.33414 13.8272 7.31687 13.7463 7.28332C13.6654 7.24977 13.5918 7.2006 13.5299 7.13862L8.66842 2.27628V15.3333C8.66842 15.5102 8.59819 15.6797 8.47317 15.8047C8.34815 15.9298 8.17858 16 8.00178 16C7.82497 16 7.65541 15.9298 7.53039 15.8047C7.40537 15.6797 7.33513 15.5102 7.33513 15.3333V2.27628L2.47363 7.13862C2.34854 7.26371 2.17888 7.33399 2.00198 7.33399C1.82507 7.33399 1.65541 7.26371 1.53033 7.13862C1.40524 7.01353 1.33496 6.84387 1.33496 6.66697C1.33496 6.49007 1.40524 6.32041 1.53033 6.19532L7.53013 0.195518C7.59204 0.133536 7.66556 0.0843647 7.74649 0.0508163C7.82742 0.0172679 7.91417 0 8.00178 0C8.08938 0 8.17613 0.0172679 8.25706 0.0508163C8.33799 0.0843647 8.41152 0.133536 8.47343 0.195518L14.4732 6.19532C14.5352 6.25723 14.5844 6.33076 14.6179 6.41168C14.6515 6.49261 14.6687 6.57936 14.6687 6.66697C14.6687 6.75458 14.6515 6.84133 14.6179 6.92226C14.5844 7.00318 14.5352 7.07671 14.4732 7.13862Z"
      fill="currentColor"
    />
  </svg>
))

export { ArrowUpIcon }
